import React from "react";
import Input from "../common/Input";
import RadioButton from "../common/RadioButton";
import Select from "../common/Select";
import Checkbox from "../common/Checkbox";

function LimaBehavioralHealth({ data, handleChange, handleSave }) {
  //   const handleDynamicDataChange = ({ currentTarget: input }) => {
  //     console.log("dynamic input: ", input, input.name, input.value);
  //     console.log("dynamic value: ", input.value);
  //     const obj = { ...data };

  //     obj.DynamicFields.results[input.name] =
  //       input.type === "checkbox" ? input.checked.toString() : input.value;
  //     setData(obj);
  //   };
  return (
    <>
      <div className="h5">Interview</div>
      <div className="row">
        <div className="col">
          <Input
            name="dateTimeOfAppointment"
            label="Date and Time of Appointment"
            type="datetime-local"
            onChange={handleChange}
            value={data.DynamicFields.results.dateTimeOfAppointment}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="clinician"
            label="Clinician"
            onChange={handleChange}
            value={data.DynamicFields.results.clinician}
          ></Input>
        </div>
      </div>
      <div className="h5 mt-4">Caregiver Information</div>
      <div className="row">
        <div className="col">
          <Input
            name="emergencyContact"
            label="Emergency Contact"
            onChange={handleChange}
            value={data.DynamicFields.results.emergencyContact}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="emergencyContactPhone"
            label="Emergency Contact Phone"
            onChange={handleChange}
            value={data.DynamicFields.results.emergencyContactPhone}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="guardian"
            label="Guardian"
            onChange={handleChange}
            value={data.DynamicFields.results.guardian}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="guardianPhone"
            label="Guardian Phone"
            onChange={handleChange}
            value={data.DynamicFields.results.guardianPhone}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="email"
            label="Email"
            onChange={handleChange}
            value={data.DynamicFields.results.email}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="fosterParent"
            label="Foster Parent"
            onChange={handleChange}
            value={data.DynamicFields.results.fosterParent}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="countyWorker"
            label="County Worker"
            onChange={handleChange}
            value={data.DynamicFields.results.countyWorker}
          ></Input>
        </div>
      </div>
      <div className="h5 mt-4">Clinical</div>
      <Input
        name="presentingProblems"
        label="Describe Presenting Problems (Including Substance Use)"
        onChange={handleChange}
        value={data.DynamicFields.results.presentingProblems}
        rows="4"
      ></Input>
      <Input
        name="history"
        label="Current Diagnosis/Prior Treatment/Prior Hospitalization"
        onChange={handleChange}
        value={data.DynamicFields.results.history}
        rows="4"
      ></Input>
      <Input
        name="currentMedications"
        label="Current Medications"
        onChange={handleChange}
        value={data.DynamicFields.results.currentMedications}
        rows="4"
      ></Input>
      <RadioButton
        name="riskOfRemoval"
        label="Is child at risk of being removed from home or school?"
        options={[
          { name: "Yes", _id: "Yes" },
          { name: "No", _id: "No" },
        ]}
        onChange={handleChange}
        value={data.DynamicFields.results.riskOfRemoval}
      ></RadioButton>
      {data.DynamicFields.results.riskOfRemoval === "Yes" ? (
        <div>
          <Input
            name="riskOfRemovalExplain"
            label="Explain"
            onChange={handleChange}
            value={data.DynamicFields.results.riskOfRemovalExplain}
            rows="4"
          ></Input>
        </div>
      ) : null}
      <RadioButton
        name="riskOfHarm"
        label="Is there risk of harm to self or others?"
        options={[
          { name: "Yes", _id: "Yes" },
          { name: "No", _id: "No" },
        ]}
        onChange={handleChange}
        value={data.DynamicFields.results.riskOfHarm}
      ></RadioButton>
      {data.DynamicFields.results.riskOfHarm === "Yes" ? (
        <div>
          <Input
            name="riskOfHarmExplain"
            label="Explain"
            onChange={handleChange}
            value={data.DynamicFields.results.riskOfHarmExplain}
            rows="4"
          ></Input>
        </div>
      ) : null}
      <Input
        name="otherComments"
        label="Other Comments"
        onChange={handleChange}
        value={data.DynamicFields.results.otherComments}
        rows="4"
      ></Input>
      <div className="h6">Type of Service Requested</div>
      <div className="row ps-4">
        <div className="col">
          <Checkbox
            name="outpatientTherapy"
            label="Outpatient Therapy"
            onChange={handleChange}
            checked={data.DynamicFields.results.outpatientTherapy === "true"}
          ></Checkbox>
        </div>
        <div className="col">
          <Checkbox
            name="intensiveHome"
            label="Empowering Families: Intensive Family Services"
            onChange={handleChange}
            checked={data.DynamicFields.results.intensiveHome === "true"}
          ></Checkbox>
        </div>
        <div className="col">
          <Checkbox
            name="caseManagement"
            label="Case Management"
            onChange={handleChange}
            checked={data.DynamicFields.results.caseManagement === "true"}
          ></Checkbox>
        </div>
      </div>
      <div className="row ps-4">
        <div className="col">
          <Checkbox
            name="inSchool"
            label="In-School Services"
            onChange={handleChange}
            checked={data.DynamicFields.results.inSchool === "true"}
          ></Checkbox>
        </div>
        <div className="col">
          <Checkbox
            name="alcoholDrugs"
            label="Alcohol & Drug Services"
            onChange={handleChange}
            checked={data.DynamicFields.results.alcoholDrugs === "true"}
          ></Checkbox>
        </div>
        <div className="col">
          <Checkbox
            name="youthDropIn"
            label="Youth Drop-In Center"
            onChange={handleChange}
            checked={data.DynamicFields.results.youthDropIn === "true"}
          ></Checkbox>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Select
            name="priority"
            label="Priority (Clinical Director or designee will review and assign the priority)"
            onChange={handleChange}
            value={data.DynamicFields.results.priority}
            options={[
              {
                name: "Routine",
                _id: "Routine",
              },
              {
                name: "Urgent (within 48 hours)",
                _id: "Urgent",
              },
              {
                name: "Not Accepted",
                _id: "NotAccepted",
              },
            ]}
          ></Select>
        </div>
        <div className="col"></div>
      </div>
      <Input
        name="priorityExplain"
        label="Explain"
        onChange={handleChange}
        value={data.DynamicFields.results.priorityExplain}
        rows="4"
      ></Input>
      <div className="row">
        <div className="col">
          <Select
            name="safyProvideMH"
            label="SAFY will be providing mental health services"
            onChange={handleChange}
            value={data.DynamicFields.results.safyProvideMH}
            options={[
              {
                name: "Yes",
                _id: "yes",
              },
              {
                name: "No",
                _id: "No",
              },
            ]}
          ></Select>
        </div>
        <div className="col"></div>
      </div>
      <Input
        name="safyMhExplain"
        label="If no, reason why and recommendation/referral given to client"
        onChange={handleChange}
        value={data.DynamicFields.results.safyMhExplain}
        rows="4"
      ></Input>
      <div className="h5 mt-4 pt-4">Payor</div>
      <div className="h6">Primary Insurance</div>
      <div>Payor Source</div>
      <div className="row ms-4">
        <div className="col-2 pt-3">
          <Checkbox
            name="selfPay1"
            label="Self-Pay"
            onChange={handleChange}
            checked={data.DynamicFields.results.selfPay1 === "true"}
          ></Checkbox>
        </div>
        <div className="col-2 pt-3">
          <Checkbox
            name="insurance1"
            label="Insurance"
            onChange={handleChange}
            checked={data.DynamicFields.results.insurance1 === "true"}
          ></Checkbox>
        </div>
        <div className="col-2 pt-3">
          <Checkbox
            name="medicaid1"
            label="Medicaid"
            onChange={handleChange}
            checked={data.DynamicFields.results.medicaid1 === "true"}
          ></Checkbox>
        </div>
        <div className="col-2 pt-3 d-flex justify-content-end">
          Medicaid Number
        </div>
        <div className="col-4 pt-1 ">
          <Input
            name="medicaidNumber1"
            label=""
            onChange={handleChange}
            value={data.DynamicFields.results.medicaidNumber1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-8">
          <Input
            name="insuranceCompany1"
            label="Insurance Company"
            onChange={handleChange}
            value={data.DynamicFields.results.insuranceCompany1}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="insurancePhone1"
            label="Phone"
            onChange={handleChange}
            value={data.DynamicFields.results.insurancePhone1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-8">
          <Input
            name="subscriber1"
            label="Subscriber"
            onChange={handleChange}
            value={data.DynamicFields.results.subscriber1}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="id1"
            label="ID #"
            onChange={handleChange}
            value={data.DynamicFields.results.id1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="group1"
            label="Group #"
            onChange={handleChange}
            value={data.DynamicFields.results.group1}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="dob1"
            label="Subscriber DOB"
            onChange={handleChange}
            value={data.DynamicFields.results.dob1}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="ssn1"
            label="SS #"
            onChange={handleChange}
            value={data.DynamicFields.results.ssn1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <Input
            name="relationship1"
            label="Relationship"
            onChange={handleChange}
            value={data.DynamicFields.results.relationship1}
          ></Input>
        </div>
      </div>
      <Input
        name="subscriberAddress1"
        label="Subscriber Address"
        onChange={handleChange}
        value={data.DynamicFields.results.subscriberAddress1}
      ></Input>
      <div className="row">
        <div className="col-4">
          <Input
            name="subscriberPhone1"
            label="Subscriber Phone"
            onChange={handleChange}
            value={data.DynamicFields.results.subscriberPhone1}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="subscriberEmployer1"
            label="Subscriber Employer"
            onChange={handleChange}
            value={data.DynamicFields.results.subscriberEmployer1}
          ></Input>
        </div>
      </div>
      <hr></hr>
      <div className="h6 mt-4">Insurance Verification</div>
      <div className="row">
        <div className="col-4">
          <Select
            name="network1"
            label="In/Out Network"
            onChange={handleChange}
            value={data.DynamicFields.results.network1}
            options={[
              {
                name: "In Network",
                _id: "in",
              },
              {
                name: "Out of Network",
                _id: "out",
              },
            ]}
          ></Select>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="insEffDate1"
            label="Effective Date"
            onChange={handleChange}
            type="date"
            value={data.DynamicFields.results.insEffDate1}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="coPay1"
            label="Co-Pay"
            onChange={handleChange}
            value={data.DynamicFields.results.coPay1}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="deductable1"
            label="Deductible"
            onChange={handleChange}
            value={data.DynamicFields.results.deductable1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="outOfPocket1"
            label="Out of Pocket Maximum"
            onChange={handleChange}
            value={data.DynamicFields.results.outOfPocket1}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="maxPayout1"
            label="Maximum Payout"
            onChange={handleChange}
            value={data.DynamicFields.results.maxPayout1}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="paymentPercent1"
            label="Payment %"
            onChange={handleChange}
            value={data.DynamicFields.results.paymentPercent1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <Input
            name="maxVisits1"
            label="Max # Visits/per person/per calendar year"
            onChange={handleChange}
            value={data.DynamicFields.results.maxVisits1}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="sessions1"
            label="# Sessions Allowed"
            onChange={handleChange}
            value={data.DynamicFields.results.sessions1}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <Select
            name="preCert1"
            label="Pre-Certification"
            onChange={handleChange}
            value={data.DynamicFields.results.preCert1}
            options={[
              {
                name: "Yes",
                _id: "yes",
              },
              {
                name: "No",
                _id: "No",
              },
            ]}
          ></Select>
        </div>
        <div className="col-8">
          <Input
            name="authorization1"
            label="Authorization"
            onChange={handleChange}
            value={data.DynamicFields.results.authorization1}
          ></Input>
        </div>
      </div>
      <Input
        name="insComments1"
        label="Comments"
        onChange={handleChange}
        value={data.DynamicFields.results.insComments1}
        rows="3"
      ></Input>
      <hr></hr>
      <div className="h6 mt-4">Secondary Insurance</div>
      <div>Payor Source</div>
      <div className="row ms-4">
        <div className="col-2 pt-3">
          <Checkbox
            name="selfPay2"
            label="Self-Pay"
            onChange={handleChange}
            checked={data.DynamicFields.results.selfPay2 === "true"}
          ></Checkbox>
        </div>
        <div className="col-2 pt-3">
          <Checkbox
            name="insurance2"
            label="Insurance"
            onChange={handleChange}
            checked={data.DynamicFields.results.insurance2 === "true"}
          ></Checkbox>
        </div>
        <div className="col-2 pt-3">
          <Checkbox
            name="medicaid2"
            label="Medicaid"
            onChange={handleChange}
            checked={data.DynamicFields.results.medicaid2 === "true"}
          ></Checkbox>
        </div>
        <div className="col-2 pt-3 d-flex justify-content-end">
          Medicaid Number
        </div>
        <div className="col-4 pt-1 ">
          <Input
            name="medicaidNumber2"
            label=""
            onChange={handleChange}
            value={data.DynamicFields.results.medicaidNumber2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-8">
          <Input
            name="insuranceCompany2"
            label="Insurance Company"
            onChange={handleChange}
            value={data.DynamicFields.results.insuranceCompany2}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="insurancePhone2"
            label="Phone"
            onChange={handleChange}
            value={data.DynamicFields.results.insurancePhone2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-8">
          <Input
            name="subscriber2"
            label="Subscriber"
            onChange={handleChange}
            value={data.DynamicFields.results.subscriber2}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="id2"
            label="ID #"
            onChange={handleChange}
            value={data.DynamicFields.results.id2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="group2"
            label="Group #"
            onChange={handleChange}
            value={data.DynamicFields.results.group2}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="dob2"
            label="Subscriber DOB"
            onChange={handleChange}
            value={data.DynamicFields.results.dob2}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="ssn2"
            label="SS #"
            onChange={handleChange}
            value={data.DynamicFields.results.ssn2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <Input
            name="relationship1"
            label="Relationship"
            onChange={handleChange}
            value={data.DynamicFields.results.relationship2}
          ></Input>
        </div>
      </div>
      <Input
        name="subscriberAddress2"
        label="Subscriber Address"
        onChange={handleChange}
        value={data.DynamicFields.results.subscriberAddress2}
      ></Input>
      <div className="row">
        <div className="col-4">
          <Input
            name="subscriberPhone2"
            label="Subscriber Phone"
            onChange={handleChange}
            value={data.DynamicFields.results.subscriberPhone2}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="subscriberEmployer2"
            label="Subscriber Employer"
            onChange={handleChange}
            value={data.DynamicFields.results.subscriberEmployer2}
          ></Input>
        </div>
      </div>
      <hr></hr>
      <div className="h6 mt-4">Insurance Verification</div>
      <div className="row">
        <div className="col-4">
          <Select
            name="network2"
            label="In/Out Network"
            onChange={handleChange}
            value={data.DynamicFields.results.network2}
            options={[
              {
                name: "In Network",
                _id: "in",
              },
              {
                name: "Out of Network",
                _id: "out",
              },
            ]}
          ></Select>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="insEffDate2"
            label="Effective Date"
            onChange={handleChange}
            type="date"
            value={data.DynamicFields.results.insEffDate2}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="coPay2"
            label="Co-Pay"
            onChange={handleChange}
            value={data.DynamicFields.results.coPay2}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="deductable2"
            label="Deductible"
            onChange={handleChange}
            value={data.DynamicFields.results.deductable2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            name="outOfPocket2"
            label="Out of Pocket Maximum"
            onChange={handleChange}
            value={data.DynamicFields.results.outOfPocket2}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="maxPayout2"
            label="Maximum Payout"
            onChange={handleChange}
            value={data.DynamicFields.results.maxPayout2}
          ></Input>
        </div>
        <div className="col">
          <Input
            name="paymentPercent2"
            label="Payment %"
            onChange={handleChange}
            value={data.DynamicFields.results.paymentPercent2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <Input
            name="maxVisits2"
            label="Max # Visits/per person/per calendar year"
            onChange={handleChange}
            value={data.DynamicFields.results.maxVisits2}
          ></Input>
        </div>
        <div className="col-4">
          <Input
            name="sessions2"
            label="# Sessions Allowed"
            onChange={handleChange}
            value={data.DynamicFields.results.sessions2}
          ></Input>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <Select
            name="preCert2"
            label="Pre-Certification"
            onChange={handleChange}
            value={data.DynamicFields.results.preCert2}
            options={[
              {
                name: "Yes",
                _id: "yes",
              },
              {
                name: "No",
                _id: "No",
              },
            ]}
          ></Select>
        </div>
        <div className="col-8">
          <Input
            name="authorization2"
            label="Authorization"
            onChange={handleChange}
            value={data.DynamicFields.results.authorization2}
          ></Input>
        </div>
      </div>
      <Input
        name="insComments2"
        label="Comments"
        onChange={handleChange}
        value={data.DynamicFields.results.insComments2}
        rows="3"
      ></Input>
      <hr></hr>
      <div className="h5 mt-4">First Appointment Scheduled For:</div>
      <div className="row ms-2">
        <div className="col-6 pt-3 mt-3">
          <Checkbox
            name="confirmAppointment"
            label="To confirm, your first appointment is on"
            onChange={handleChange}
            checked={data.DynamicFields.results.confirmAppointment === "true"}
          ></Checkbox>
        </div>
        <div className="col-3">
          <Input
            name="appointmentDateTime"
            label="Date and Time"
            onChange={handleChange}
            value={data.DynamicFields.results.appointmentDateTime}
            type="datetime-local"
          ></Input>
        </div>
        <div className="col-3">
          <Input
            name="appointmentTherapist"
            label="Therapist"
            onChange={handleChange}
            value={data.DynamicFields.results.appointmentTherapist}
          ></Input>
        </div>
      </div>
      <div className="row ms-2">
        <div className="col-6">
          <Checkbox
            name="location"
            label="Do you know where our office is located?"
            onChange={handleChange}
            checked={data.DynamicFields.results.location === "true"}
          ></Checkbox>
        </div>
      </div>
      <div className="row ms-2">
        <div className="col-6">
          <Checkbox
            name="ourTelephone"
            label="Do you have our main telephone number?"
            onChange={handleChange}
            checked={data.DynamicFields.results.ourTelephone === "true"}
          ></Checkbox>
        </div>
      </div>
      <div className="row ms-2">
        <div className="col-6">
          <Checkbox
            name="informedCopay"
            label="If you have a copay, you will be informed before your first appointment.  Your copay will be due before each scheduled session."
            onChange={handleChange}
            checked={data.DynamicFields.results.informedCopay === "true"}
          ></Checkbox>
        </div>
      </div>
      <button className="btn btn-primary" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default LimaBehavioralHealth;

// {
// 	"riskOfRemoval": {
// 		"type": "checkbox",
// 		"label": "Is child at risk of being removed from home or school?",
// 		"value": ""
// 	},
// 	"riskOfRemovalExplain": {
// 		"type": "input",
// 		"label": "If yes, explain",
// 		"value": ""
// 	},
// 	"riskOfHarm": {
// 		"type": "checkbox",
// 		"label": "Is there risk of harm to self or others?",
// 		"value": ""
// 	},
// 	"riskOfHarmExplain": {
// 		"type": "input",
// 		"label": "If yes, explain",
// 		"value": ""
// 	},
// 	"otherComments": {
// 		"type": "input",
// 		"label": "Other Comments",
// 		"value": ""
// 	},
// 	"typeOfService": {
// 		"type": "select",
// 		"label": "Type of service being requested",
// 		"value": "",
// 		"options": [{
// 			"name": "Outpatient Therapy",
// 			"_id": "OutpatientTherapy"
// 		}, {
// 			"name": "Case Management (CPST)",
// 			"_id": "CPST"
// 		}, {
// 			"name": "Alcohol and Drug Services",
// 			"_id": "AlcoholDrug"
// 		}, {
// 			"name": "Intensive Home-Based Therapy",
// 			"_id": "IntensiveHome"
// 		}, {
// 			"name": "In-School Services",
// 			"_id": "School"
// 		}]
// 	},
// 	"priority": {
// 		"type": "select",
// 		"label": "Priority (Clinical Director or designee will review and assign the priority)",
// 		"value": "",
// 		"options": [{
// 			"name": "Routine",
// 			"_id": "Routine"
// 		}, {
// 			"name": "Urgent (within 48 hours)",
// 			"_id": "Urgent"
// 		}, {
// 			"name": "Not Accepted",
// 			"_id": "NotAccepted"
// 		}]
// 	},
// 	"prioityExplain": {
// 		"type": "input",
// 		"label": "Explain",
// 		"value": ""
// 	}
// }
